module.exports = __webpack_public_path__ + "static/media/yax.175c5585.png";